import moment from "moment";
import Papa from "papaparse";
import { v4 as uuidv4 } from "uuid";

const surchargeTitles = [
    /* 
        FUEL SURCHARGE is the only row surcharge that should have a partnerCost, other listed rows should only have customer cost,
        according to our deal with Freja. This is handled in the invoice order mapping.
    */
    "FUEL SURCHARGE",
    "GOGREEN PLUS - CARBON REDUCED",
    "DEMAND SURCHARGE",
];

function cleanValue(value) {
    // The values are wrapped in single quotes so we remove these
    // (e.g. "'FUEL SURCHARGE'" is displayed as 'FUEL SURCHARGE' if we don't remove the quotes)
    return value?.replace(/'/g, "");
}

function parseAdditionalCharges(row, isCustomsDuty) {
    /*  Additional charges take up 7 indexes each,
        "'XC1 Code'",
        "'XC1 Name'",
        "'XC1 Charge'",
        "'XC1 Tax Code'",
        "'XC1 Tax'",
        "'XC1 Discount'",
        "'XC1 Total'",
    */
    const additionalCharges = [];
    const additionalChargesStartIndex = 90;
    for (let i = additionalChargesStartIndex; i < row.length; i += 7) {
        if (i > row.length) break;

        const name = cleanValue(row[i + 1]);
        const tax = cleanValue(row[i + 4]);
        const total = cleanValue(row[i + 6]);

        const cost = !!total ? parseFloat(total) : 0;
        const rowVat = !!tax && parseInt(tax) > 0 && !isCustomsDuty;
        if (cost > 0) {
            additionalCharges.push({
                title: name,
                cost,
                vat: rowVat,
                surcharge: !isCustomsDuty && surchargeTitles.includes(name),
                key: uuidv4(),
            });
        }
    }

    const chargedWeight = cleanValue(row[68]) || "0";
    additionalCharges.push({
        title: `Fakturerad vikt: ${chargedWeight} kg`,
        key: uuidv4(),
    });

    return additionalCharges;
}

function parse({ data, fileName }) {
    const cleanData = data.replace(/"/g, "'");

    let rows = Papa.parse(cleanData, {
        skipEmptyLines: true,
    });

    if (rows.errors.length) {
        window.alert(
            "Misslyckades med att hantera filen.\nFelmeddelanden:\n" +
                rows.errors.map((err) => err.message).join("\n"),
        );
    }

    // Slice 2 since first row is headers and the second row is a summary row
    const orderRows = rows.data.slice(2);

    const isCustomsDuty = orderRows.some((row) => {
        return row.some(
            (cell) => cleanValue(cell).toUpperCase() === "DUTY TAX PAID",
        );
    });

    let orders = [];
    orderRows.forEach((row) => {
        const vatValue = cleanValue(row[73]);
        const isVat = !!vatValue && parseInt(vatValue) > 0 && !isCustomsDuty;
        const totalCostNoVatStr = cleanValue(row[70]);
        const totalCostVatStr = cleanValue(row[71]);
        const totalShipmentCostNoVat = !!totalCostNoVatStr
            ? parseFloat(totalCostNoVatStr)
            : 0;
        const totalShipmentCostVat = !!totalCostVatStr
            ? parseFloat(totalCostVatStr)
            : 0;
        const totalShipmentCost =
            (isVat ? totalShipmentCostVat : totalShipmentCostNoVat) || 0;

        const additionalCharges = parseAdditionalCharges(row, isCustomsDuty);
        const trackingNumber = cleanValue(row[23]);
        const sender = cleanValue(row[37]);
        const recipient = cleanValue(row[50]);

        orders.push({
            fileName: fileName,
            transporter: "DHL EXPRESS",
            partner: "FREJA",
            trackingNumber,
            reference: cleanValue(row[27]),
            currentInvoiceNumber: cleanValue(row[3]),
            date: moment(cleanValue(row[9]), "YYYYMMDD").format("YYYY-MM-DD"),
            title: isCustomsDuty ? "Tull" : "Transport",
            sender,
            senderCountry: cleanValue(row[44]),
            recipient,
            recipientCountry: cleanValue(row[57]),
            totalShipmentCost,
            totalShipmentCostVat,
            totalShipmentCostNoVat,
            vat: isVat,
            rows: additionalCharges,
        });
    });

    return orders;
}

export default {
    parse,
};
